// Premium Color Palette
export const PREMIUM_COLORS = [
    '#1a1a2e', // Deep Navy
    '#16213e', // Dark Blue
    '#0f3460', // Royal Blue
    '#e94560', // Coral Red
    '#ff6b6b', // Salmon
    '#feca57', // Golden Yellow
    '#48dbfb', // Sky Blue
    '#1dd1a1', // Emerald
    '#5f27cd', // Royal Purple
    '#ff9ff3', // Pink
    '#54a0ff', // Ocean Blue
    '#00d2d3', // Teal
    '#ff6348', // Tomato
    '#2ed573', // Lime Green
    '#ffffff', // White
    '#2f3542', // Charcoal
];

// Grid settings
export const GRID_SIZE = 40;

// Storage key for persistence
export const STORAGE_KEY = 'whiteboard_data';

// Default stroke widths
export const STROKE_WIDTHS = [2, 4, 6, 8, 12, 16, 24];

// Tool keys for keyboard shortcuts
export const TOOL_SHORTCUTS = {
    'v': 'select',
    's': 'select',
    'p': 'pen',
    'l': 'line',
    'c': 'curve',
    'r': 'rect',
    'o': 'circle',
    't': 'triangle',
    'b': 'bucket',
    'e': 'eraser',
};

// Font families for text tool
export const FONT_FAMILIES = [
    'Inter',
    'Arial',
    'Helvetica',
    'Georgia',
    'Comic Sans MS',
    'Courier New',
];

// Font sizes for text tool
export const FONT_SIZES = [12, 16, 20, 24, 32, 48, 64, 96];
